const type = {
  PRICE_ASC: 3,
  PRICE_DESC: 4,
  SALE_NUM_ASC: 5,
  SALE_NUM_DESC: 6
};

export default type;
